import { render } from "./commission.vue?vue&type=template&id=3cf607b6&scoped=true"
import script from "./commission.vue?vue&type=script&lang=js"
export * from "./commission.vue?vue&type=script&lang=js"

import "./commission.vue?vue&type=style&index=0&id=3cf607b6&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf607b6"]])

export default __exports__